import { EmployeeImportFormat } from '@/common/graphql';

import { type ImportSelectionValue, MANAGERIAL_ACCOUNTING_IMPORT_TYPE } from './types';

export const importTypeOptions: ImportSelectionValue[] = [
  EmployeeImportFormat.Create,
  EmployeeImportFormat.GeneralInformation,
  EmployeeImportFormat.JobHistoryContract,
  MANAGERIAL_ACCOUNTING_IMPORT_TYPE,
];

export const importTypeLabel: Record<ImportSelectionValue, string> = {
  [EmployeeImportFormat.Create]: 'Add New Employees',
  [EmployeeImportFormat.GeneralInformation]: 'Update Current General Information',
  [EmployeeImportFormat.JobHistoryContract]: 'Update Manager/Job/Contract information',
  [MANAGERIAL_ACCOUNTING_IMPORT_TYPE]: 'Managerial Accounting',
};
